import React, { useCallback, useEffect, useMemo, useState } from "react";
import Select from "react-select";
import DropDown from "../../Components/DropDown";
import "./index.css";

import {
  GetVerticalsList,
  GetAllVerticalKeys,
  CreateUpdateSalesPerson,
  GetAllSalesPersons,
  GetReportingManagerName
} from "../../Services/Dashboard/tableGridService";
import { useNavigate } from "react-router-dom";
import { GrAddCircle } from "react-icons/gr";
import { RiDeleteBin5Line } from "react-icons/ri";
import {
  EMPLOYEE_TYPE,
  Transfer_ID,
  DROPDOWN_DETAILS,
  USER_DETAILS,
  REPORTING_SALES_PERSON_DROPDOWN_COUNT,
} from "../../Constants/constants";
import { transformPositionCodeDetailsByTrasferId } from "../../Utils/assignAutoTransferId";
import { EMPLOYEE_TYPE_VALUE } from "../../Utils/constants";

const AddNewUser = () => {
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [reportingSalesPersonId, setReportingSalesPersonId] = useState();
  const [uniqueKeys, setUniqueKeys] = useState([]);
  const [userDetails, setUserDetails] = useState({
    status: USER_DETAILS.ACTIVE,
  });
  const [selected, setSelected] = useState(null);
  const [verticals, setVerticals] = useState();
  const [verticalFields, setVerticalFields] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [salesPersonAdditionalDetails, setSalesPersonAdditionalDetails] =
    useState([]);
  const [verticalValue, setVerticalValue] = useState(null);
  const [isApisLoading, setIsApisLoading] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    let verticalOptions = [];
    const dataRes = GetVerticalsList({ input: { refType: "vertical" } })
      .then((res) => {
        res?.data?.data?.forEach((vericalItem, index) => {
          verticalOptions.push({
            value: vericalItem,
            label: vericalItem.refValue,
          });
        });
      })
      .catch((error) => {
        setErrorMessage("Unable to fetch Verticals at the moment *");
      });
    setVerticals(verticalOptions);
  }, []);

  const navigate = useNavigate();

  const onFieldChange = (event) => {
    setErrorMessage("");
    const name = event.target.name;
    const value = event.target.value;
    setUserDetails({ ...userDetails, [name]: value });
  };

  const onChangeReportingManager = (event) => {
    setReportingSalesPersonId(event?.value?.userId);
    setUserDetails({
      ...userDetails,
      reportingSalesPersonId: event?.value?.reportingSalesPersonId,
    });
  };

  const fetchManagers = async (name) => {
    setIsLoading(true);
    try {
      const body = {
        inputParameters: {
          queryName: "dynamic_search_sales_person_by_name",
          name,
        },
      };
      const response = await GetReportingManagerName(body);

      const fetchedOptions = response?.data?.data?.map((manager) => ({
        label: manager?.empName,
        value: manager || {},
      })) || [];

      setOptions(fetchedOptions);
    } catch (error) {
      console.error("Error fetching managers:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (value) => {
    setInputValue(value);
    if (value.length >= 3) {
      fetchManagers(value);
    } else {
      setOptions([]);
    }
  };

  const verticalOnChange = (selectedOption) => {
    const { value } = selectedOption;
    setVerticalValue(value);
    GetAllVerticalKeys({
      input: value,
    })
      .then((res) => {
        setVerticalFields(res?.data?.data);
        const uniqueKeys = Array.from(
          new Set(res?.data?.data?.map((item) => item.refType))
        );
        setUniqueKeys(uniqueKeys);
        setInitialSalesPersonsDetail(uniqueKeys);
      })
      .catch((error) => {
        setErrorMessage("Unable to fetch Vertical Keys at the moment *");
        console.log(error);
      });
    setSelected(selectedOption);
  };

  const setInitialSalesPersonsDetail = (dropDownNames) => {
    const positionCodeDetails = dropDownNames?.map((ele) => ({ refType: ele }));
    setSalesPersonAdditionalDetails(
      [{
        positionCodeAdditionalDetails: positionCodeDetails.concat({
          refType: Transfer_ID,
          refValue: null,
        }),
        uniqueId: Math.random(),
      }]);
  };

  const getDropdownFields = (name) => {
    const filteredDropdownFields = dropdownOptions.filter((ele) => {
      return ele?.value?.refType === name;
    });
    return filteredDropdownFields;
  };

  const selectOnChange = async (action, positionCodeIndex, refIndex) => {
    const newAdditionalFields = salesPersonAdditionalDetails.slice();
    try {
      setIsApisLoading(true);
      const [modifiedVertical] = await transformPositionCodeDetailsByTrasferId(
        newAdditionalFields,
        positionCodeIndex,
        refIndex,
        action?.value?.refValue,
        verticalValue
      );
      setSalesPersonAdditionalDetails(modifiedVertical || newAdditionalFields);
      setIsApisLoading(false);
    } catch (e) {
      setIsApisLoading(false);
    }
  };

  const addVertical = () => {
    const newRow = [];
    uniqueKeys?.map((ele) => newRow?.push({ refType: ele }));
    newRow.push({ refType: Transfer_ID });
    const salesPersonAdditionalDetailsCopy =
      salesPersonAdditionalDetails.slice();
    salesPersonAdditionalDetailsCopy?.push({
      positionCodeAdditionalDetails: newRow,
      uniqueId: Math.random(),
    });
    setSalesPersonAdditionalDetails(salesPersonAdditionalDetailsCopy);
  };

  const deleteVertical = (index) => {
    const deleteRow = salesPersonAdditionalDetails.slice();
    deleteRow.splice(index, 1);
    setSalesPersonAdditionalDetails(deleteRow);
  };

  const onSave = async () => {
    setErrorMessage("");
    if (verticalValue?.refValue === DROPDOWN_DETAILS.RETAILER) {
      salesPersonAdditionalDetails?.forEach((positionCodeDetail) => {
        if (positionCodeDetail?.positionCodeAdditionalDetails) {
          const existingVertical = positionCodeDetail?.positionCodeAdditionalDetails.find(
            (entry) => entry?.refType === DROPDOWN_DETAILS.VERTICAL
          );
          if (!existingVertical) {
            positionCodeDetail?.positionCodeAdditionalDetails.push({
              refType: DROPDOWN_DETAILS.VERTICAL,
              refValue: verticalValue?.refValue,
            });
          }
        }
      });
    }
    await CreateUpdateSalesPerson({
      ...userDetails,
      salesPersonAdditionalDetails: [verticalValue],
      positionCodeAdditionalDetails: salesPersonAdditionalDetails,
    }).then((res) => {
      if (res.status === 200) {
        navigate(-1);
      } else {
        setErrorMessage("Somthing went wrong *");
      }
    });
  };

  const checkRefValue = (uniqueId) => {
    const refValueObj = salesPersonAdditionalDetails.find(
      (ele) => ele.uniqueId === uniqueId
    );
    const { positionCodeAdditionalDetails } = refValueObj;
    const isRefValue = positionCodeAdditionalDetails?.find(
      (item) => !item.refValue
    );
    if (!isRefValue) {
      return false;
    } else {
      return true;
    }
  };

  const isSaveEnabled = () => {
    let resultant = !salesPersonAdditionalDetails.length;
    salesPersonAdditionalDetails?.forEach((ele) => {
      resultant = !checkRefValue(ele?.uniqueId);
    });
    return resultant;
  };

  const onDiscard = () => {
    setUserDetails(null);
    navigate(-1);
  };

  const getTransferIdValue = (positionCodeIndex) => {
    return (
      salesPersonAdditionalDetails[
        positionCodeIndex
      ].positionCodeAdditionalDetails.find((pca) => pca.refType === Transfer_ID)
        ?.refValue || ""
    );
  };

  useEffect(() => {
    setDropdownOptions(
      verticalFields &&
      Array.isArray(verticalFields) &&
      verticalFields?.map((item) => {
        return {
          label: item.refValue,
          value: { refType: item.refType, refValue: item.refValue },
        };
      })
    );
  }, [verticalFields.length]);

  return (
    <div className="add-new-user-parent-container">
      <div className="add-new-user-heading-container">
        <div className="add-new-user-heading-items">
          <h3 className="text-base font-bold">Add New Sales Person</h3>
        </div>
      </div>
      <div className="add-new-user-inner-container">
        <div className="add-new-user-inner-parent-container">
          <div className="add-new-user-inner-input-data-container">
            <div className="add-new-user-inner-heading-container">
              <h3 className="text-base font-bold">Sales Person Details</h3>
            </div>
            <div className="add-new-user-inner-data-container">
              <div className="add-new-user-inner-data-input-container">
                <label>Name</label>
                <input
                  onFocus={() => setErrorMessage("")}
                  onChange={(e) => onFieldChange(e)}
                  name="empName"
                  className="add-new-user-inner-input"
                />
              </div>
              <div className="add-new-user-inner-data-input-container">
                <label>Employee code</label>
                <input
                  onFocus={() => setErrorMessage("")}
                  onChange={(e) => onFieldChange(e)}
                  name="empCode"
                  className="add-new-user-inner-input"
                />
              </div>
            </div>
            <div className="add-new-user-inner-data-container">
              <div className="add-new-user-inner-data-input-container">
                <label>Email</label>
                <input
                  name="empEmail"
                  onChange={(e) => onFieldChange(e)}
                  className="add-new-user-inner-input"
                />
              </div>
              <div className="add-new-user-inner-data-input-container">
                <label>Employee Type</label>
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      width: 154,
                    }),
                  }}
                  name="empType"
                  options={EMPLOYEE_TYPE_VALUE.map((type) => ({
                    value: type,
                    label: type,
                  }))}
                  onChange={(e) => {
                    setUserDetails({
                      ...userDetails,
                      empType: e?.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className="add-new-user-inner-data-container">
              <div className="add-new-user-inner-data-input-container">
                <label>Status</label>
                <input
                  disabled={true}
                  placeholder={USER_DETAILS.ACTIVE}
                  name="status"
                  onChange={(e) => onFieldChange(e)}
                  className="add-new-user-inner-input"
                />
              </div>
              <div className="add-new-user-inner-data-input-container">
                <label>RealmId</label>
                <input
                  onFocus={() => setErrorMessage("")}
                  name="realmId"
                  onChange={(e) => onFieldChange(e)}
                  className="add-new-user-inner-input"
                />
              </div>
            </div>
            <div className="add-new-user-inner-data-container">
              <div className="add-new-user-inner-data-input-container">
                <label>user_id</label>
                <input
                  name="userId"
                  type="number"
                  onChange={(e) => onFieldChange(e)}
                  className="add-new-user-inner-input"
                />
              </div>
              <div className="add-new-user-inner-data-input-container">
                <label>Reporting Manager Name</label>
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      width: 154,
                    }),
                  }}
                  isLoading={isLoading}
                  options={options}
                  onInputChange={handleInputChange}
                  onChange={(e) => onChangeReportingManager(e)}
                  noOptionsMessage={() =>
                    inputValue.length < 3
                      ? "Enter at least 3 characters"
                      : "No results found"
                  }
                  placeholder="Search"
                  isClearable
                />
              </div>
            </div>
            <div className="add-new-user-inner-data-container">
              <div className="add-new-user-inner-data-input-container">
                <label>Phone Number</label>
                <input
                  type="number"
                  onChange={(e) => onFieldChange(e)}
                  name="empPhoneNumber"
                  className="add-new-user-inner-input"
                />
              </div>
              <div className="add-new-user-inner-data-input-container">
                <label>Reporting Manager UserId</label>
                <input
                  disabled={true}
                  value={reportingSalesPersonId}
                  name="reportingSalesPersonId"
                  className="add-new-user-inner-input"
                />
              </div>
            </div>
            <br />
            <br />
            <div className="add-new-user-inner-data-container">
              <div className="add-new-user-inner-data-input-container">
                <label>Vertical</label>
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      width: 154,
                    }),
                  }}
                  options={verticals}
                  onChange={verticalOnChange}
                />
              </div>
            </div>
            <div>
              {salesPersonAdditionalDetails?.map((data, index) => {
                const isRefValuePresent = checkRefValue(data?.uniqueId);
                return (
                  <div
                    className="add-new-user-creatable-dropdown-container"
                    key={data?.uniqueId}
                  >
                    <DropDown
                      selected={selected}
                      uniqueKeys={uniqueKeys}
                      getDropdownFields={getDropdownFields}
                      selectOnChange={selectOnChange}
                      data={data}
                      positionCodeIndex={index}
                      isEditable={false}
                    >
                      {(verticalValue.refValue === DROPDOWN_DETAILS.RESELLER || verticalValue.refValue === DROPDOWN_DETAILS.RETAILER) && (
                        <>
                          <label style={{ marginRight: "10px" }}>
                            Transfer ID
                          </label>
                          <input
                            readOnly
                            style={{ width: "196px" }}
                            name="transferId"
                            onChange={(e) =>
                              selectOnChange(
                                {
                                  label: e.target.value,
                                  value: { refValue: e.target.value },
                                },
                                index,
                                uniqueKeys?.length
                              )
                            }
                            value={getTransferIdValue(index)}
                            className="user-detail-input"
                          />
                        </>
                      )}
                    </DropDown>
                    <div className="add-new-user-creatable-dropdown-button-contanier">
                      {uniqueKeys.length > 0 && !isRefValuePresent && (
                        <GrAddCircle
                          className="add-new-user-creatable-dropdown-button"
                          onClick={() => addVertical()}
                        />
                      )}
                      <RiDeleteBin5Line
                        className="add-new-user-creatable-dropdown-button"
                        onClick={() => deleteVertical(index)}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="add-new-user-inner-button-container">
              <button
                disabled={!isSaveEnabled() || isApisLoading}
                onClick={() => onSave()}
                className="add-new-user-inner-save-changes-btn"
              >
                Save Changes
              </button>
              <button
                onClick={() => onDiscard()}
                className="add-new-user-inner-discard-btn"
              >
                Discard
              </button>
            </div>
            {errorMessage !== "" && (
              <h3 className="text-base font-bold add-new-user-error-message">
                {errorMessage}
              </h3>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewUser;
